<template>
  <el-container :class="{teacher:teacher,mechanism:mechanism}">
    <el-header>
      <!-- Header -->
      <Header :username="username" :avatar="avatar" @showMenu="showMenu"></Header>
    </el-header>
    <el-container>
      <el-aside :class="{hideMenu:isCollapse}">
        <!-- Aside -->
        <Left :isCollapse="isCollapse"></Left>
      </el-aside>
      <el-container>
        <el-main>
          <!-- Main -->
          <div class="min">
            <div class="title">
              <el-breadcrumb class="app-breadcrumb" separator="/index" separator-class="el-icon-arrow-right">
                <transition-group name="breadcrumb">
                  <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
                    <span v-if="index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
                    <a v-else @click.prevent="handleLink(index,item)">{{ item.meta.title }}</a>
                  </el-breadcrumb-item>
                </transition-group>
              </el-breadcrumb>
            </div>
            <div class="content_inner">
              <router-view/>
            </div>
          </div>
        </el-main>
        <el-footer>
          <!-- Footer -->
          {{technicalSupport}}
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import { technicalSupport } from '../config/index'
import Header from '../components/header'
import Left from '../components/left.vue'
export default {
  name: 'common', 
  components: {
    Header,
    Left
  },
  data(){
    return {
      username:this.$store.state.realname,
      avatar:this.$store.state.avatar,
      isCollapse:false,
      levelList: null,
      teacher:false,
      mechanism:false,
      technicalSupport,
    }
  },
  created(){
    this.getBreadcrumb()
    let rid  = Number(this.$store.state.rid)  
    if(rid === 5){
      this.mechanism = true
      let res = JSON.parse(localStorage.getItem('res'))
      this.username = res.organName
    }else if(rid === 6){
      this.teacher = true
    }

  },
  methods:{
    showMenu(data){
      this.isCollapse = data
    },
    getBreadcrumb() {
      let route = this.$route
      let routeArr = route.meta.parent
      let parentArr = []
      if(routeArr){
        routeArr.forEach(function(v,k){
          parentArr.push(v)
        })
      }
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)

      const first = matched[0]
      if (!this.isIndex(first)) {
        matched = [{ path: '/index', meta: { title: '首页' }}].concat(matched)
      }
     let listArr = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
     let listLength  = listArr.length
      if(parentArr.length > 0 ){
        parentArr.forEach(function(v,k){
          if(k === 0){
            listArr.splice(listLength - 1,0,v)
          }else if(k === 1){
            listArr.splice(listLength ,0,v)
          }
          
        })
        // listArr.splice(listLength - 1,0,parentArr)
      }
      this.levelList = listArr
    },
    isIndex(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name === '首页'
    },
    pathCompile(path) {
      const pathToRegexp = require('path-to-regexp');
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(index,item) {
      if(index >= 2){
        this.$router.go(-1)
      }else{
        const { redirect, path } = item
        if (redirect) {
          this.$router.push(redirect)
          return
        }
        this.$router.push(this.pathCompile(path))
      }
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
}
</script>
<style lang="scss">
 
</style>
<style lang="scss" scoped>
  @import '../assets/scss/common.scss';
  // 
  .title{
    padding-left:20px;
  }
  .title,.el-breadcrumb{
    height:40px;
    background: #fff;
    // padding:0 0 0 20px;
    line-height:40px;
    font-size: 14px;
    font-weight: bold;
  }
  
</style>
